export const globalSearchTypes = {
    GLOBAL_SEARCH_REQUEST: "GLOBAL_SEARCH_REQUEST",
    GLOBAL_SEARCH_POP_UP_REQUEST: "GLOBAL_SEARCH_POP_UP_REQUEST",
    GLOBAL_SEARCH_MODEL_REQUEST: "GLOBAL_SEARCH_MODEL_REQUEST",
    GLOBAL_SEARCH_SUCCESS: "GLOBAL_SEARCH_SUCCESS",
    GLOBAL_SEARCH_FAILURE: "GLOBAL_SEARCH_FAILURE"
};

export const searchRequest = (req) => ({
    type: globalSearchTypes.GLOBAL_SEARCH_REQUEST,
    payload: req
});

export const searchPopUpUpdate = (req) => ({
    type: globalSearchTypes.GLOBAL_SEARCH_POP_UP_REQUEST,
    payload: req
});
export const isGlobalSearchModelVisible = (req) => ({
    type: globalSearchTypes.GLOBAL_SEARCH_MODEL_REQUEST,
    payload: req
});

export const searchSuccess = (resp) => ({
    type: globalSearchTypes.GLOBAL_SEARCH_SUCCESS,
    payload: resp
});

export const searchFailure = (error) => ({
    type: globalSearchTypes.GLOBAL_SEARCH_FAILURE,
    payload: error
});